import React from 'react';
import SectionHeader from './SectionHeader';

const WhyChooseUs: React.FC = () => {
  const benefits: string[] = [
    'Instant payments and secure transactions',
    'Centralized resident and property management',
    'Transparent reporting and downloadable records',
    'Easy communication with announcements and resources',
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Why Choose Us Section */}
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-8 md:py-16">
        {/* Header */}
        <SectionHeader
          heading="Why choose us"
          subtitle="Your reliable partner for smarter solutions"
        />

        {/* Content Grid */}
        <div className="grid md:grid-cols-2 gap-4 md:gap-12 items-center">
          {/* Image */}
          <div className="rounded-3xl overflow-hidden shadow-xl">
            <img
              src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
              alt="Team collaboration"
              className="w-full h-full object-cover"
              width="800"
              height="600"
            />
          </div>

          {/* Benefits List */}
          <div className="space-y-4 md:space-y-8">
            {benefits.map((benefit: string, index: number) => (
              <div
                key={index}
                className="text-base md:text-xl font-semibold text-gray-900 py-2"
              >
                {benefit}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyChooseUs;
